var sharedES = {
    "ExperienceSwitcher.discover": "Discover",
    "ExperienceSwitcher.product_asset": "Happy Asset",
    "ExperienceSwitcher.product_force": "Happy Force",
    "ExperienceSwitcher.product_property": "Happy Property",
    "ExperienceSwitcher.sign_into_another_company": "Sign into another company",
    "ExperienceSwitcher.sign_out": "Sign out",
    "ExperienceSwitcher.signed_in_companies": "Signed in companies",
    "Nav.business_select_heading": "Company"
};

export { sharedES as default };
